import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import FieldLabel from '../components/FieldLabel';
import { getFieldLabel, matchCountryValue } from '../utils/formHelpers';

const MultiSelectField = ({
    field,
    data,
    change,
    hasError,
    resolveFieldOptions,
    resolveLookupOptions,
    countries = [],
}) => {
    // Prefer lookup catalogues (e.g. departure_dates) when optionsSource is set.
    const options =
        (field.optionsSource && resolveLookupOptions?.(field))
        || resolveFieldOptions?.(field)
        || field.options
        || [];
    const rawSelected = Array.isArray(data[field.key]) ? data[field.key] : [];
    const selectedValues = rawSelected.map((val) => {
        if (field.optionsSource === 'countries') {
            return matchCountryValue(val, countries) || val;
        }
        return val;
    });
    const selectedOptions = options.filter((option) =>
        selectedValues.some((v) => String(v) === String(option.value))
    );

    return (
        <Autocomplete
            multiple
            size="small"
            options={options}
            value={selectedOptions}
            onChange={(_, newValue) => change(field.key, newValue.map((item) => item.value))}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(option, value) => String(option.value) === String(value.value)}
            disableCloseOnSelect
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip
                        {...getTagProps({ index })}
                        key={option.value}
                        label={option.label}
                        size="small"
                        sx={{ borderRadius: '8px' }}
                    />
                ))
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={<FieldLabel label={getFieldLabel(field)} tooltip={field.tooltip} />}
                    placeholder={
                        selectedValues.length === 0
                            ? (field.placeholder || 'Select…')
                            : ''
                    }
                    error={hasError}
                    helperText={hasError ? 'This field is required' : ''}
                />
            )}
            sx={{
                '& .MuiOutlinedInput-root': {
                    alignItems: 'flex-start',
                    py: 0.5,
                },
            }}
        />
    );
};

export default MultiSelectField;
